// extracted by mini-css-extract-plugin
export var filterIncDec = "_dc-0";
export var leftBorder = "_dc-1";
export var rightBorder = "_dc-2";
export var stringInput = "_dc-3";